var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechCapacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_5_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.1,332c0,9.2,7.4,16.6,16.6,16.6c9.2,0,16.6-7.4,16.6-16.6c0-9.2-7.4-16.6-16.6-16.6 C207.6,315.4,200.1,322.8,200.1,332z M216.8,326.5c3.1,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5c-3.1,0-5.5-2.5-5.5-5.5 S213.7,326.5,216.8,326.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.6,332c0,9.2,7.4,16.6,16.6,16.6c9.2,0,16.6-7.4,16.6-16.6c0-9.2-7.4-16.6-16.6-16.6 C274.1,315.4,266.6,322.8,266.6,332z M283.2,326.5c3.1,0,5.5,2.5,5.5,5.5s-2.5,5.5-5.5,5.5c-3.1,0-5.5-2.5-5.5-5.5 S280.2,326.5,283.2,326.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "neutral_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.6,289.9c-2.9,2.7-6.8,4.4-11.1,4.4h11.1V289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.8,94.9c0-34-42.7-61.7-97.6-65.7c-4.3-0.5-8.7-0.8-13.2-0.8c-4.5,0-8.9,0.3-13.2,0.8 c-54.9,4-97.6,31.7-97.6,65.7v232.7c0,18.9,13.3,35.9,34.5,48l-34.5,51.7v44.3h177.3l44.3-66.5v-44.3h-15.4 c9.5-9.8,15.4-21.1,15.4-33.2V94.9z M250,48.1c6.7,0,12.6,0.6,17.6,1.7c15.2,3.1,23.2,9.5,23.6,11.9c-0.6,3.2-14.6,13.5-41.2,13.5 c-26.7,0-40.7-10.4-41.2-13.5C209.3,58.5,223.3,48.1,250,48.1z M208.8,86.2c10.9,5.4,25.3,8.7,41.2,8.7c16,0,30.4-3.3,41.2-8.7 v14.2c-0.6,3.2-14.6,13.5-41.2,13.5c-26.7,0-40.7-10.4-41.2-13.5V86.2z M189.1,63.8v36.6c0,17.1,22.2,30.2,51.1,32.7v5.5 c-45.6-2.8-78.8-24.2-78.8-43.8C161.4,83.9,171.9,72.4,189.1,63.8z M338.6,398.4l-34,51H161.4V434l4.5-6.7h150.7l22.2-33.2V398.4z  M180.6,405.1l13.6-20.4c16.4,5.8,35.4,9.3,55.8,9.3c22.6,0,43.6-4.1,61.1-11.1h8.3l-14.8,22.2H180.6z M338.6,265.5 c-2.9-2.7-6.8-4.4-11.1-4.4c-9.2,0-16.6,7.4-16.6,16.6c0,9.2,7.4,16.6,16.6,16.6c4.3,0,8.1-1.7,11.1-4.4v4.4h-11.1v11.1h11.1v22.2 c0,20.9-37.9,44.3-88.6,44.3c-50.7,0-88.6-23.4-88.6-44.3v-15.5c2.9,2.7,6.8,4.4,11.1,4.4c9.2,0,16.6-7.4,16.6-16.6 c0-2.8-0.9-5.3-2.1-7.6c2.3,1.2,4.8,2.1,7.6,2.1c9.2,0,16.6-7.4,16.6-16.6c0-9.2-7.4-16.6-16.6-16.6c-9.2,0-16.6,7.4-16.6,16.6 c0,2.8,0.9,5.3,2.1,7.6c-2.3-1.2-4.8-2.1-7.6-2.1c-4.3,0-8.1,1.7-11.1,4.4V134.4c18.3,14.8,46.5,24.6,78.8,26.4v51.4 c-15.9-7.4-36.6-16.3-45.6-16.3c-16.4,0-32,15.6-32,32c0,16.4,15.6,32,32,32c10.9,0,39.7-13.3,55.4-21c15.6,7.7,44.2,21,55.4,21 c16.4,0,32-15.6,32-32c0-16.4-15.6-32-32-32c-9,0-29.7,8.9-45.6,16.3v-51.4c32.3-1.7,60.5-11.6,78.8-26.4V265.5z M333.1,277.7 c0,3.1-2.5,5.5-5.5,5.5c-3.1,0-5.5-2.5-5.5-5.5c0-3.1,2.5-5.5,5.5-5.5C330.6,272.2,333.1,274.6,333.1,277.7z M166.9,299.9 c0-3.1,2.5-5.5,5.5-5.5c3.1,0,5.5,2.5,5.5,5.5c0,3.1-2.5,5.5-5.5,5.5C169.4,305.4,166.9,302.9,166.9,299.9z M189.1,277.7 c0-3.1,2.5-5.5,5.5-5.5c3.1,0,5.5,2.5,5.5,5.5c0,3.1-2.5,5.5-5.5,5.5C191.5,283.2,189.1,280.8,189.1,277.7z M227.1,227.8 c-14.8,6.7-28.5,12.2-32.5,12.3c-5.6,0-12.3-6.7-12.3-12.3c0-5.6,6.7-12.3,12.3-12.3C198.5,215.7,212.3,221.1,227.1,227.8z  M272.9,227.9c14.8-6.7,28.6-12.2,32.5-12.3c5.6,0,12.3,6.7,12.3,12.3c0,5.6-6.7,12.3-12.3,12.3 C301.4,240,287.7,234.6,272.9,227.9z M259.8,138.6v-5.5c28.9-2.5,51.1-15.6,51.1-32.7V63.8c17.2,8.6,27.7,20.1,27.7,31.1 C338.6,114.4,305.5,135.8,259.8,138.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.4,
    y: 316.5,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.6,
    y: 294.3,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.8,
    y: 272.2,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.8,
    y: 294.3,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.1,294.3c9.2,0,16.6-7.4,16.6-16.6c0-9.2-7.4-16.6-16.6-16.6c-9.2,0-16.6,7.4-16.6,16.6 C244.5,286.9,251.9,294.3,261.1,294.3z M261.1,272.2c3.1,0,5.5,2.5,5.5,5.5c0,3.1-2.5,5.5-5.5,5.5c-3.1,0-5.5-2.5-5.5-5.5 C255.5,274.6,258,272.2,261.1,272.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.9,
    y: 316.5,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.1,
    y: 294.3,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.2,
    y: 272.2,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 316.5,
    className: "st0",
    width: 22.2,
    height: 11.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.3,
    y: 294.3,
    className: "st0",
    width: 22.2,
    height: 11.1
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechCapacity;